module.exports = __webpack_public_path__ + "img/find_in_page.718bec8d.svg";